export function compactNumber(value: number | null | undefined, digits = 2): string {
  if (value == null || Number.isNaN(value)) return '—'
  return new Intl.NumberFormat('zh-CN', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  }).format(value)
}

export function signed(value: number | null | undefined, digits = 2): string {
  if (value == null || Number.isNaN(value)) return '—'
  return `${value >= 0 ? '+' : ''}${compactNumber(value, digits)}`
}

export function percent(value: number | null | undefined, digits = 2): string {
  if (value == null || Number.isNaN(value)) return '—'
  return `${signed(value, digits)}%`
}

export function compactAmount(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return '—'
  if (Math.abs(value) >= 100_000_000) return `${compactNumber(value / 100_000_000, 2)} 亿`
  if (Math.abs(value) >= 10_000) return `${compactNumber(value / 10_000, 1)} 万`
  return compactNumber(value, 0)
}

export function shortTime(value: string | null | undefined): string {
  if (!value) return '—'
  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) return value
  return parsed.toLocaleString('zh-CN', {
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  })
}

export function barLabel(value: string, period: string): string {
  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) return value
  if (period === '1d' || period === '1w') {
    return parsed.toLocaleDateString('zh-CN', { month: '2-digit', day: '2-digit' })
  }
  return parsed.toLocaleTimeString('zh-CN', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  })
}
